module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/empty-cart-df6b393c78ed00f4b9c63790213b5c58.svg";